export default __webpack_public_path__ + "static/media/@joshuacc.c6656a8a.jpeg";